/**
 * PlacementTracker page - renders the tracker with sample data.
 * TODO: Replace sampleData with API response when backend is ready.
 */
import React from 'react';
import PlacementTracker from './PlacementTracker';
import { sampleData } from './data';

export const PlacementTrackerPage = () => {
  return <PlacementTracker data={sampleData} />;
};
